export const FieldTagSelectorCustomInputRegEx = /^"(.*)"$/;
